import React, { useState } from 'react';
import { useShop } from '../../context/ShopContext';
import { formatINR } from '../../data/products';
import { 
  Sparkles, 
  Calendar, 
  Clock, 
  Upload, 
  User, 
  Phone, 
  Gem, 
  CheckCircle2, 
  ShieldCheck, 
  Plus, 
  Search, 
  FileText, 
  MessageSquare,
  Lock,
  ArrowRight
} from 'lucide-react';

export default function AdminCustomOrders() {
  const { liveGoldRates, addToast } = useShop();

  const [activeTab, setActiveTab] = useState('custom-orders'); // 'custom-orders', 'rate-lock-bookings', 'appointments'
  const [searchTerm, setSearchTerm] = useState('');
  const [isNewBookingModalOpen, setIsNewBookingModalOpen] = useState(false);

  // Advance Gold Bookings
  const [rateLockBookings, setRateLockBookings] = useState([
    {
      id: 'GB-2026-401',
      customerName: 'Vikramaditya Rathore',
      phone: '+91 98290 88776',
      lockedRate: 6765,
      purity: '22KT (916)',
      gramsBooked: 100,
      totalBookingValue: 676500,
      advancePaid: 200000,
      balanceDue: 476500,
      bookingDate: '2026-10-02',
      deliveryTargetDate: '2026-11-20 (Wedding)',
      status: 'Rate Locked (Active)'
    },
    {
      id: 'GB-2026-402',
      customerName: 'Meenakshi Sundaram',
      phone: '+91 94440 22334',
      lockedRate: 7380,
      purity: '24KT (999)',
      gramsBooked: 50,
      totalBookingValue: 369000,
      advancePaid: 184500,
      balanceDue: 184500,
      bookingDate: '2026-10-06',
      deliveryTargetDate: '2026-10-29 (Dhanteras Delivery)',
      status: 'Ready for Vault Delivery'
    }
  ]);

  // Custom Bespoke Design Orders
  const [customOrders, setCustomOrders] = useState([
    {
      id: 'CAD-801',
      client: 'Neha Chawla',
      phone: '+91 98110 33221',
      title: 'Heritage Peacock Jadau Hasli with Real Emerald Beads',
      metal: '22KT Hallmarked Gold (approx 65g)',
      stones: 'Uncut Polki & Zambian Emeralds',
      cadStatus: 'CAD 3D Model Approved by Client',
      karigarAssigned: 'Master Artisan Babulal, Jaipur',
      estimatedQuote: 480000,
      advanceReceived: 150000,
      deliveryDate: '2026-11-10'
    },
    {
      id: 'CAD-802',
      client: 'Devendra Kothari',
      phone: '+91 97240 55443',
      title: 'Platinum 950 Solitaire Engagement Band with Hidden Halo',
      metal: 'Platinum 950 (approx 7.2g)',
      stones: '1.20 Carat VVS1 E-Color Solitaire (IGI Certified)',
      cadStatus: 'Casting & Stone Setting in Progress',
      karigarAssigned: 'Surat Diamond Setting Workshop',
      estimatedQuote: 225000,
      advanceReceived: 100000,
      deliveryDate: '2026-10-25'
    }
  ]);

  const handleWhatsAppUpdate = (clientName, phone, title, quote) => {
    const text = encodeURIComponent(`Namaste ${clientName} ji, Update on your custom jewellery piece "${title}" from M.L. Jewellers & Kitchenware. Casting and certification are progressing as per schedule. For queries, contact our master concierge.`);
    window.open(`https://api.whatsapp.com/send?phone=${phone.replace(/[^0-9]/g, '')}&text=${text}`, '_blank');
  };

  return (
    <div style={{ maxWidth: '1240px', margin: '0 auto' }}>
      
      {/* Top Banner */}
      <div style={{
        background: '#ffffff',
        borderRadius: '8px',
        padding: '1.25rem 1.6rem',
        border: '1px solid #e0e0e0',
        marginBottom: '1.5rem',
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: '1rem',
        boxShadow: '0 1px 3px rgba(0,0,0,0.05)'
      }}>
        <div>
          <div style={{ display: 'inline-flex', alignItems: 'center', gap: '0.4rem', color: '#2874f0', fontSize: '0.72rem', fontWeight: 800, textTransform: 'uppercase', letterSpacing: '0.6px', marginBottom: '0.2rem' }}>
            <Sparkles size={14} />
            <span>BESPOKE BRIDAL CAD & BULLION RATE LOCKS</span>
          </div>
          <h2 style={{ fontSize: '1.45rem', fontWeight: 800, color: '#212121', margin: 0 }}>
            Custom Orders & Advance Rate Bookings
          </h2>
          <p style={{ margin: '0.2rem 0 0', fontSize: '0.82rem', color: '#616161' }}>
            Advance Gold Rate Booking for weddings, CAD 3D design approvals, artisan job cards & VIP showroom appointments.
          </p>
        </div>

        <div style={{ display: 'flex', gap: '0.6rem' }}>
          <button
            onClick={() => addToast?.('New Custom Order intake form launched', 'info')}
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '0.4rem',
              padding: '0.55rem 1rem',
              borderRadius: '4px',
              border: 'none',
              background: '#2874f0',
              color: '#ffffff',
              fontWeight: 700,
              fontSize: '0.82rem',
              cursor: 'pointer'
            }}
          >
            <Plus size={15} />
            <span>New Bespoke Request</span>
          </button>
        </div>
      </div>

      {/* Tabs */}
      <div style={{ display: 'flex', gap: '0.5rem', marginBottom: '1.25rem', borderBottom: '1px solid #e0e0e0', paddingBottom: '0.5rem' }}>
        {[
          { id: 'custom-orders', label: 'Bespoke Custom Jewellery Orders', icon: <Gem size={15} /> },
          { id: 'rate-lock-bookings', label: 'Advance Gold Rate Bookings (Wedding)', icon: <Lock size={15} /> }
        ].map(t => (
          <button
            key={t.id}
            onClick={() => setActiveTab(t.id)}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '0.45rem',
              padding: '0.55rem 0.9rem',
              borderRadius: '4px',
              border: 'none',
              background: activeTab === t.id ? '#e8f0fe' : 'transparent',
              color: activeTab === t.id ? '#2874f0' : '#424242',
              fontWeight: activeTab === t.id ? 700 : 500,
              fontSize: '0.82rem',
              cursor: 'pointer'
            }}
          >
            {t.icon}
            <span>{t.label}</span>
          </button>
        ))}
      </div>

      {/* Tab 1: Bespoke Custom Orders */}
      {activeTab === 'custom-orders' && (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
          {customOrders.map(c => (
            <div key={c.id} style={{ background: '#ffffff', borderRadius: '8px', border: '1px solid #e0e0e0', padding: '1.3rem', boxShadow: '0 1px 3px rgba(0,0,0,0.04)' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', flexWrap: 'wrap', gap: '0.8rem', marginBottom: '0.8rem' }}>
                <div>
                  <span style={{ fontSize: '0.72rem', fontWeight: 800, color: '#2874f0', background: '#eff6ff', padding: '0.15rem 0.5rem', borderRadius: '3px' }}>
                    JOB CARD #{c.id}
                  </span>
                  <h3 style={{ fontSize: '1.1rem', fontWeight: 800, color: '#1e293b', margin: '0.3rem 0 0.15rem' }}>{c.title}</h3>
                  <div style={{ fontSize: '0.8rem', color: '#64748b' }}>Client: <strong>{c.client}</strong> • {c.phone}</div>
                </div>

                <div style={{ textAlign: 'right' }}>
                  <div style={{ fontSize: '1.25rem', fontWeight: 900, color: '#0f172a' }}>{formatINR(c.estimatedQuote)}</div>
                  <div style={{ fontSize: '0.72rem', color: '#15803d', fontWeight: 700 }}>Advance Paid: {formatINR(c.advanceReceived)}</div>
                </div>
              </div>

              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '0.8rem', background: '#f8fafc', padding: '0.9rem', borderRadius: '6px', border: '1px solid #e2e8f0', marginBottom: '0.9rem', fontSize: '0.8rem' }}>
                <div>
                  <div style={{ color: '#64748b', fontSize: '0.72rem' }}>Metal Spec:</div>
                  <div style={{ fontWeight: 700, color: '#1e293b' }}>{c.metal}</div>
                </div>
                <div>
                  <div style={{ color: '#64748b', fontSize: '0.72rem' }}>Gems & Stones:</div>
                  <div style={{ fontWeight: 700, color: '#1e293b' }}>{c.stones}</div>
                </div>
                <div>
                  <div style={{ color: '#64748b', fontSize: '0.72rem' }}>Karigar Workshop:</div>
                  <div style={{ fontWeight: 700, color: '#1e293b' }}>{c.karigarAssigned}</div>
                </div>
                <div>
                  <div style={{ color: '#64748b', fontSize: '0.72rem' }}>Delivery Target:</div>
                  <div style={{ fontWeight: 800, color: '#2563eb' }}>{c.deliveryDate}</div>
                </div>
              </div>

              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <span style={{ fontSize: '0.75rem', fontWeight: 700, color: '#065f46', background: '#ecfdf5', padding: '0.25rem 0.6rem', borderRadius: '4px', border: '1px solid #a7f3d0' }}>
                  ● {c.cadStatus}
                </span>

                <div style={{ display: 'flex', gap: '0.5rem' }}>
                  <button
                    onClick={() => handleWhatsAppUpdate(c.client, c.phone, c.title, c.estimatedQuote)}
                    style={{
                      background: '#25D366',
                      color: '#fff',
                      border: 'none',
                      padding: '0.4rem 0.8rem',
                      borderRadius: '4px',
                      fontSize: '0.75rem',
                      fontWeight: 700,
                      cursor: 'pointer',
                      display: 'inline-flex',
                      alignItems: 'center',
                      gap: '0.3rem'
                    }}
                  >
                    <MessageSquare size={13} />
                    <span>WhatsApp Progress</span>
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* Tab 2: Rate Lock Advance Bookings */}
      {activeTab === 'rate-lock-bookings' && (
        <div style={{ background: '#ffffff', borderRadius: '8px', border: '1px solid #e0e0e0', overflow: 'hidden' }}>
          <div style={{ padding: '1.1rem 1.4rem', borderBottom: '1px solid #f0f0f0', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <div>
              <h3 style={{ fontSize: '1.05rem', fontWeight: 800, color: '#1e293b', margin: 0 }}>
                Advance Bullion Rate Lock Contracts
              </h3>
              <p style={{ margin: '0.2rem 0 0', fontSize: '0.78rem', color: '#64748b' }}>
                Protects wedding clients from bullion market inflation. Rate fixed on contract signing day.
              </p>
            </div>
          </div>

          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.82rem', textAlign: 'left' }}>
            <thead>
              <tr style={{ background: '#f8fafc', borderBottom: '1px solid #e2e8f0', color: '#475569', fontSize: '0.74rem', textTransform: 'uppercase' }}>
                <th style={{ padding: '0.8rem 1rem' }}>Contract ID</th>
                <th style={{ padding: '0.8rem 1rem' }}>Client</th>
                <th style={{ padding: '0.8rem 1rem' }}>Locked Rate & Weight</th>
                <th style={{ padding: '0.8rem 1rem' }}>Contract Value</th>
                <th style={{ padding: '0.8rem 1rem' }}>Advance Paid</th>
                <th style={{ padding: '0.8rem 1rem' }}>Balance Due</th>
                <th style={{ padding: '0.8rem 1rem' }}>Delivery Schedule</th>
              </tr>
            </thead>
            <tbody>
              {rateLockBookings.map(b => (
                <tr key={b.id} style={{ borderBottom: '1px solid #f1f5f9' }}>
                  <td style={{ padding: '0.8rem 1rem', fontWeight: 800, color: '#2874f0' }}>{b.id}</td>
                  <td style={{ padding: '0.8rem 1rem' }}>
                    <div style={{ fontWeight: 700, color: '#1e293b' }}>{b.customerName}</div>
                    <div style={{ fontSize: '0.72rem', color: '#64748b' }}>{b.phone}</div>
                  </td>
                  <td style={{ padding: '0.8rem 1rem', color: '#334155' }}>
                    <div style={{ fontWeight: 800, color: '#d97706' }}>₹{b.lockedRate}/g ({b.purity})</div>
                    <div style={{ fontSize: '0.72rem', color: '#64748b' }}>Booked: {b.gramsBooked} grams</div>
                  </td>
                  <td style={{ padding: '0.8rem 1rem', fontWeight: 800, color: '#0f172a' }}>{formatINR(b.totalBookingValue)}</td>
                  <td style={{ padding: '0.8rem 1rem', fontWeight: 700, color: '#15803d' }}>{formatINR(b.advancePaid)}</td>
                  <td style={{ padding: '0.8rem 1rem', fontWeight: 800, color: '#b91c1c' }}>{formatINR(b.balanceDue)}</td>
                  <td style={{ padding: '0.8rem 1rem', color: '#2563eb', fontWeight: 600 }}>{b.deliveryTargetDate}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

    </div>
  );
}
